class AddProductForm extends HTMLElement {
  constructor() {
    super();
    this.selectText = this.getAttribute("select-text");
    this.addingText = this.getAttribute("adding-text");
    this.errorText = this.getAttribute("error-text");
    this.maxQuantityText = this.getAttribute("max-quantity-text");
  }

  connectedCallback() {
    const form = this.querySelector("#product-form");
    const buyNowButton = this.querySelector("#buy-now");
    const addToCartButton = this.querySelector("#add-to-cart");
    const current = this.querySelector("#current");
    const quantity = this.querySelector("#quantity");
    const maxQuantity = this.querySelector("#max-quantity");

    addToCartButton.textContent = this.selectText;

    if (!form) return;

    const submitButton = form.querySelector('button[type="submit"]');
    const defaultText = submitButton.textContent;

    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      submitButton.textContent = this.addingText;
      submitButton.disabled = true;

      const formData = new FormData(form);

      if (Number(current.value) + 1 > Number(maxQuantity.value)) {
        submitButton.textContent = this.maxQuantityText;
        setTimeout(() => {
          submitButton.textContent = this.selectText;
        }, 1200);
        return;
      }
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
          },
        });

        if (!response.ok) {
          submitButton.textContent = this.errorText;
          setTimeout(() => {
            submitButton.textContent = this.addingText;
          }, 1200);
          return;
        }

        addToCartButton.textContent = this.selectText;

        const data = await response.json();

        if (data.quantity > maxQuantity.value) {
          data.quantity = maxQuantity.value;
        }

        current.value = data.quantity;

        quantity.value = 1;

        // Add to cart
        const responseCart = await fetch("/cart.js", {
          method: "GET",
        });

        const dataCart = await responseCart.json();

        document.querySelectorAll("[data-cart-count]").forEach((el) => {
          el.textContent = dataCart.item_count;
        });
      } catch (error) {
        console.error("Error agregando al carrito", error);
      } finally {
        submitButton.textContent = defaultText;
        submitButton.disabled = false;
      }
    });

    if (buyNowButton) {
      buyNowButton.addEventListener("click", async () => {
        const formData = new FormData(form);

        await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
          },
        });

        window.location.href = "/checkout";
      });
    }
  }
}

customElements.define("add-product-form", AddProductForm);
